import { render, staticRenderFns } from "./StandaloneMediaViewer.vue?vue&type=template&id=79753200&scoped=true"
import script from "./StandaloneMediaViewer.vue?vue&type=script&lang=js"
export * from "./StandaloneMediaViewer.vue?vue&type=script&lang=js"
import style0 from "./StandaloneMediaViewer.vue?vue&type=style&index=0&id=79753200&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79753200",
  null
  
)

export default component.exports